import { render } from "./FavsView.vue?vue&type=template&id=7245d08e"
import script from "./FavsView.vue?vue&type=script&lang=js"
export * from "./FavsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__